module.exports = __webpack_public_path__ + "img/why-decoration-2.1a7184f2.jpg";